import React from "react";
import { Chip } from "@mui/material";

interface UserRoleProps {
  role: string;
}

export const RoleChip = (props: UserRoleProps) => {
  if (props.role === undefined) {
    return (null)
  }

  return (
    <Chip label={props.role} size="small" sx={{ mr: 0.25 }} />
  )
}
